let gainsEnvironment = 'dev';
//let gainsEnvironment = 'prod'

const devConfig = {
	gainsApi: {
		URL: 'https://api-dev.gains.earthi.world',
		REGION: 'eu-west-2',
		NAME: 'gains-back-end-dev'
	},
	qcApi: {
		URL: 'https://h0n2gp2t3k.execute-api.eu-west-2.amazonaws.com/dev',
		REGION: 'eu-west-2',
		NAME: 'qc-back-end-dev'
	},
	cognito: {
		REGION: 'eu-west-2',
		USER_POOL_ID: 'eu-west-2_oKbWrU50D',
		APP_CLIENT_ID: '7t19llkovcnghhqukrfeh7412c',
		IDENTITY_POOL_ID: 'eu-west-2:471e29e3-6266-450c-aef0-13c08bc87e6a'
	},
	idleTimeout: 1000 * 60 * 60
};

const prodConfig = {
	gainsApi: {
		URL: 'https://api.gains.earthi.world',
		REGION: 'eu-west-2',
		NAME: 'gains-back-end-prod'
	},
	qcApi: {
		URL: 'https://vukufy6563.execute-api.eu-west-2.amazonaws.com/prod',
		REGION: 'eu-west-2',
		NAME: 'qc-back-end-prod'
	},
	cognito: {
		REGION: 'eu-west-2',
		USER_POOL_ID: 'eu-west-2_plUl26ZwS',
		APP_CLIENT_ID: '5c5i4aom7t7tcrftcr5bt7euvs',
		IDENTITY_POOL_ID: 'eu-west-2:2ec2c7a7-e87e-4e4d-adab-55d302dfa533',
		AuthenticationFlowType: 'USER_PASSWORD_AUTH'
	},
	idleTimeout: 1000 * 60 * 30
};


const devMapboxToken =
	'pk.eyJ1IjoibW9qb3NiZWFucyIsImEiOiJjbGlkMTN2N2cwNTU0M2VzMDdqbDhsMmFwIn0.HFEl4nHKHUcp_Rz6QOGSnw';
const prodMapboxToken =
	'pk.eyJ1IjoiZWFydGgtaS10ZWNoIiwiYSI6ImNsamg4cXR1cDAyYjkzY254ems4aWY1amMifQ.8MLjrfX13N_HS1Gk7kFJXA';

let mapboxToken;
let config;

switch (gainsEnvironment) {
	case 'prod':
		config = prodConfig;
		mapboxToken = prodMapboxToken;
		break;
	case 'dev':
	default:
		config = devConfig;
		mapboxToken = devMapboxToken;
		break;
}

const gainsApiEndpoints = {
	regions: '/v1/regions',
	createRegion: '/v1/regions',
	updateRegion: '/v1/regions/${id}', // eslint-disable-line no-template-curly-in-string

	sites: '/v1/sites',
	createSite: '/v1/sites',
	updateSite: '/v1/sites/${id}', // eslint-disable-line no-template-curly-in-string
	deleteSite: '/v1/sites/${id}', // eslint-disable-line no-template-curly-in-string
	siteGroups: '/v1/sites/${id}/groups', // eslint-disable-line no-template-curly-in-string
	siteTypes: '/v1/site-types',
	siteInfo: '/v1/sites/${id}/info', // eslint-disable-line no-template-curly-in-string
	kmlDownload: '/v1/kml-download/${id}', // eslint-disable-line no-template-curly-in-string
	fetchSubsiteInfo: '/v1/sites/subsites/${id}', // eslint-disable-line no-template-curly-in-string

	fetchSiteCapacities: '/v1/capacity/${id}', // eslint-disable-line no-template-curly-in-string
	addSiteCapacity: '/v1/capacity/${id}', // eslint-disable-line no-template-curly-in-string
	updateSiteCapacity: '/v1/capacity/${id}', // eslint-disable-line no-template-curly-in-string
	deleteSiteCapacity: '/v1/capacity/${id}', // eslint-disable-line no-template-curly-in-string

	groups: '/v1/groups',
	createGroup: '/v1/groups',
	updateGroup: '/v1/groups/${id}', // eslint-disable-line no-template-curly-in-string
	deleteGroup: '/v1/groups/${id}', // eslint-disable-line no-template-curly-in-string
	groupSites: '/v1/groups/${id}/sites', // eslint-disable-line no-template-curly-in-string

	groupTypes: '/v1/group-types',
	createGroupType: '/v1/group-types',
	updateGroupType: '/v1/group-types/${id}', // eslint-disable-line no-template-curly-in-string
	deleteGroupType: '/v1/group-types/${id}', // eslint-disable-line no-template-curly-in-string

	countries: '/v1/countries',
	commodities: '/v1/commodities',

	users: '/users',
	updateUser: '/users/${id}', // eslint-disable-line no-template-curly-in-string
	deleteUser: '/users/${id}', // eslint-disable-line no-template-curly-in-string
	approveUser: '/update-user-role',
	sendReport: '/ga/report',
	sendUserGAReport: '/ga/report/${id}', // eslint-disable-line no-template-curly-in-string

	cognitoGroups: '/cognito-groups',
	cognitoGroupUser: '/users/${id}/cognito-groups' // eslint-disable-line no-template-curly-in-string
};

const qcApiEndpoints = {
	updateCaptureCapacities: '/smelters/update_capacities',
	fetchSiteComments: '/smelters/comments/site', 
	createSiteComment: '/smelters/comments/site',
	updateSiteComment: '/smelters/comments/site/${id}', // eslint-disable-line no-template-curly-in-string
	deleteSiteComment: '/smelters/comments/site/${id}', // eslint-disable-line no-template-curly-in-string
	fetchCommentStatuses: '/smelters/comments/statuses',
	fetchCommentCategories: '/smelters/comments/categories',
	getPresignedUrl: '/smelters/comments/attachment',
}

const mapbox_styles = [
	{
		stylename: 'streets',
		url: 'streets-v12',
		text: 'black'
	},
	{
		stylename: 'outdoors',
		url: 'outdoors-v12',
		text: 'black'
	},
	{
		stylename: 'light',
		url: 'light-v11',
		text: 'black'
	},
	{
		stylename: 'dark',
		url: 'dark-v11',
		text: 'white'
	},
	{
		stylename: 'satellite',
		url: 'satellite-v9',
		text: 'white'
	}
];

const mapBoxLayerStyles = {
	fill_paint: {
		'fill-color': '#cceeff',
		'fill-opacity': 0.5
	},

	line_paint: {
		'line-color': '#cceeff',
		'line-width': 3
	}
};

export default {
	mapboxToken,
	gainsApiEndpoints,
	qcApiEndpoints,
	mapbox_styles,
	mapBoxLayerStyles,
	gainsEnvironment,
	...config
};
